export const ContainerLogoOverlay = tw.div`
absolute top-0 left-0 w-full h-full flex items-center justify-center z-10
`;
import tw from "tailwind-styled-components";

export const ContainerHome = tw.div`
w-screen h-screen
flex flex-col md:flex-row
min-h-screen
`;

export const ContainerLeft = tw.div`
relative
w-full md:w-3/5
min-h-screen
md:after:absolute md:after:inset-0 md:after:bg-black/60 md:after:z-[1] md:after:pointer-events-none
`;

export const BackgroundImg = tw.img`
w-full h-full min-h-screen min-w-full
object-cover absolute z-0 top-0 left-0 bottom-0 right-0
`;
export const ContainerLogin = tw.div`
flex items-center justify-center
bg-[#bfbfbf] dark:bg-dark-bg
w-full md:w-2/5
h-fit md:h-full
rounded-2xl md:rounded-none shadow-lg md:shadow-none
px-6 md:p-0
absolute md:static inset-0 md:inset-auto m-auto md:m-0 max-w-[95vw] md:max-w-none
transition-colors duration-300
`;

export const ContainerLogo = tw.div`
w-fit h-[90%]
flex flex-col justify-center 
gap-5 pl-24
`;

export const Logo = tw.img`
w-60
`;

export const ContainerSlogan = tw.div`
flex items-center
`;

export const Line = tw.hr`
flex-grow mr-3
border-t border-white 
`;

export const Slogan = tw.p`
text-sm text-white font-bold
`;

export const MainContainer = tw.div`
w-full 
flex flex-col items-center
`;

export const HomeSlogan = tw.p`
text-base text-white font-bold
`;

export const HomeLogoImage = tw.img`
w-24
`;

export const ContainerRight = tw.div`
w-[300px] md:w-[450px]  px-8 md:px-12 bg-gray-50
rounded-xl
`;
